import React, { Component } from 'react';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/cart-header-dux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Product from './ProductPage/Product';
import Event from './ProductPage/Event';

import VintageDescription from './ProductPage/VintageDescription';
import TastingNotes from './ProductPage/TastingNotes';
import StillThirsty from './ProductPage/StillThirsty';
import DinnerDetails from './ProductPage/DinnerDetails';
import Layout from '../../ui/Layout';
import Loading from '../../ui/Loading';
import ProductNotFound from './ProductNotFound';

class ProductPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    const {
      getShopProductBySlug,
      clearGetShopProductBySlug,
      clearPostAddToCart,
      match: { params }
    } = this.props;

    const { slug } = params || {};
    clearGetShopProductBySlug();
    clearPostAddToCart();
    getShopProductBySlug(slug);

    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-product-detail',
      'page-template-page-templatesshop-template-product-detail-php',
      'page',
      'page-id-220',
      'page-child',
      'parent-pageid-212',
      'no-sidebar',
      'headroom',
      'loaded',
      'nav-closed',
      'desktop-device',
      'headroom--top',
      'headroom--not-bottom',
      'headroom--unpinned'
      //  'headroom--unpinned'      <----------
    );
  }
  componentDidUpdate(prevProps) {
    const {
      getShopProductBySlug,
      match: { params: { slug } }
    } = this.props;

    const {
      match: { params: { slug: prevSlug } }
    } = prevProps;

    if (slug === prevSlug) return;

    window.scrollTo(0, 0);

    getShopProductBySlug(slug);
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-product-detail',
      'page-template-page-templatesshop-template-product-detail-php',
      'page',
      'page-id-220',
      'page-child',
      'parent-pageid-212',
      'no-sidebar',
      'headroom',
      'loaded',
      'nav-closed',
      'desktop-device',
      'headroom--top',
      'headroom--not-bottom'
    );
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);
    const {
      user,
      product,
      loading,
      postAddToCart,
      setCartAdd,
      getProductError
    } = this.props;

    const handleAddToCart = ({ payload }) => {
      const {
        qty
      } = payload || {};

      const {
        productKitId,
        productSkuId,
        Name: name,
        unitPrice
      } = product || {};

      const dataPayload = Object.assign(
        { event: 'add-to-cart' },
        { productKitId, productSkuId, name, unitPrice, qty }
      );

      if (window && window.dataLayer) {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({ ...dataPayload });
      }
      postAddToCart({ payload }, null, null, () => setCartAdd(payload));
    };

    const { ProductID, productTypeId } = product || {};
    const isProduct = productTypeId === 1; // 1 - wine

    if (getProductError || (!ProductID && !loading)) return <ProductNotFound />;

    return (
      <Layout>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main
              id="main"
              className="site-main shop-page nohero extra product-detail-page"
            >
              <div className="container">

                {loading && <Loading fullPage scrollToTop />}

                {!loading &&
                  <div>
                    <Product
                      {...product}
                      onAddToCart={handleAddToCart}
                      user={user}
                    />
                    <TastingNotes {...product} />
                    {isProduct && <VintageDescription {...product} />}
                  </div>}

              </div>

              {!loading && <StillThirsty {...product} />}

            </main>
          </div>

          <div className="container text-right">
            <div className="row justify-content-center">
              <div className="col-md-10 text-right">
                <a href="#" className="back-to-top" onClick={scrollToTop}>
                  Back to top
                </a>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error: getProductError,
    result: product,
    inProgress: loading
  } = state.getShopProductBySlug.toJS();

  const {
    result: user
  } = state.postLogin.toJS();

  return {
    user,
    product,
    loading,
    getProductError
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getShopProductBySlug: fetchDux.getShopProductBySlug.createAction,
      clearGetShopProductBySlug: fetchDux.getShopProductBySlug.clearAction,
      postAddToCart: fetchDux.postAddToCart.createAction,
      clearPostAddToCart: fetchDux.postAddToCart.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ProductPage);
